import { userConstants } from '../constants/login.constants';

function companyHierarchy(state = {}, action) {
    switch (action.type) {
        case userConstants.COMPANYHIERARCHY_REQUEST:
            return {
                loading: true
            };
        case userConstants.COMPANYHIERARCHY_SUCCESS:
            return {
                items: action.companyHierarchy
            };
        case userConstants.COMPANYHIERARCHY_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default companyHierarchy;
